export default {
  ENTER_NAME: `Enter name`,
  JOIN: `Join now`,
  CHOOSE_A_PICTURE: `Select Icon`,
  SUPPORTED_BY: `Supported by NetEase IM`,
  MEETING_EXPIRED: `Meeting link has expired`,
  GRID_VIEW: `Grid view`,
  PRESENTER_VIEW: `Presenter view`,
  EXPAND: `Expand participants panel`,
  COLLAPSE: `Collapse participants panel`,
  NO_DEVICE: `No device detected. Please try again or connect to another device.`,
  CONFIRM_LEAVE: `Leave meeting now?`,
  BROWSER: `Browser`,
  LOOKING_AT_THE_SCREEN: `Viewing {name}’s screen`,
  DEVICE_NAME: `Device name`,
  MUTE_ON_ENTRY: `Currently participants are muted by default.`,
  NOT_ALLOWED_TURNED_ON_DEVICE: `The moderator has restricted microphone use `,
  NEW_HOST: `{name} is now the host`,
  OFFLINE: `Network problem. Please check your network settings.`,
  CONNECTION_IS_UNSTABLE: `Network connection is unstable.`,
  UNSTABLE_CONNECTION: `Connection is unstable`,
  TRYING_TO_RECONNECT: `Reconnecting...`,
  CONNECTION_FAILED: `Connection failed`,
  NETWORK_CONNECTION_FAILED: `Network connection failed. Call ended.`,
  THE_HOST_ASKED_TO_TURN_ON_YOUR_CAMERA: `The host requested open your camera `,
  REJECT: `Reject`,
  OPEN: `Open`,
  EXPERIENCE: `How was your experience?`,
  OTHER_FEEDBACK: `Any other feedbacks?`,
  THANKS: `Thanks for using POPO meeting`,
  CANCEL: `Cancel`,
  LEAVE: `Leave`,
  SUBMIT: `Submit`,
  DURATION: `Duration`,
  GREAT: `Great`,
  ISSUES: `Had Issues`,
  REQUEST_MIC: `Allow access to the microphone`,
  REQUEST_CAMERA: `Allow access to the camera`,
  REQUEST_MIC_CONTENT: `Allow access to the microphone in System Preference`,
  REQUEST_CAMERA_CONTENT: `Allow access to the camera in System Preference`,
  CONFIRM: `Confirm`,
  INVITE_YOU_TO_THE_MEETING: `Invite you to join`,
  CONFERENCE_THEME: `Meeting Topic`,
  CONFERENCE_NUMBER: `ID`,
  CONFERENCE_LINKS: `Invites Link`,
  ALLOW_MEMBERS_TO_JOIN_THROUGH_WEB_BROWSER: `Allow members join meeting via browser`,
  THE_MEETING_INFORMATION_HAS_BEEN_COPIED_TO_THE_CLIPBOARD: `Copied`,
  SHARE_TO_CONVERSATION: `Share to Chat`,
  COPY_MEETING_LINK: `Copy `,
  SHARE_INVITATION_CARD: `Share`,
  STOP_SHARE: `{name} stopped sharing`,
  START_TIME: `Starting Time`,
  SPEAKING: `Speaking`,
  HOST: `Host`,
  CAMERA: `Camera`,
  MICROPHONE: `Microphone`,
  SPEAKER: `Speaker`,
  TURNED_OFF_MIC_BY_HOST: `You’re muted by the host.`,
  TURNED_OFF_CAMERA_BY_HOST: `Your camera has been turned off by the host.`,
  MEETING_ENDING: `The meeting has ended`,
  MEETING_NOT_EXIST: `Meeting does not exist`,
  LEAVE_MEETING: `Leave`,
  KICK_OUT: `You are removed from the meeting by the host.`,
  CAMERA_ON: `Camera on`,
  CAMERA_OFF: `Camera off`,
  MIC_ON: `Unmute`,
  MIC_OFF: `Mute`,
  SETTINGS: `Settings`,
  THE_MODERATOR_HAS_CLOSED_THE_CHAT_IN_THE_MEETING: `The moderator has closed the chat in the meeting`,
  THE_HOST_HAS_TURNED_OFF_THE_MEETING_CHAT_FUNCTION: `The host has turned off the meeting chat function`,
  THE_HOST_HAS_STARTED_CHATTING_IN_THE_MEETING: `The host has started chatting in the meeting`,
  CHAT: `Chat`,
  NEW_NEWS: `New news`,
  NO_MORE_NEWS: `No more news`,
  LOADING: `Loading`,
  SEND_A_MESSAGE_TO_EVERYONE: `Send a message to everyone ...`,
  SEND: `Send`,
  LINE_FEED: `Line feed`,
  ME: `Me`,
  SWITCH_MIC_TIPS: `available when mic is open`,
  AUDIOVIDEO_CONFERENCE: `Audiovideo conference`,
  MEMBER_MANAGEMENT: `Members`,
  CLOSE: `Close`,
  MEMBER: `Members`,
  HOST_OPEN_MIC: `The host requests to turn on your microphone`,
  HOST_OPEN_CAMERA: `The host requests to turn on your camera`,
  IOS_UNDER_13: `IOS 13 and the following versions are not currently supported, please update and try again.`,
  NOT_SHARE_SCREEN: `Can't share screen`,
  SYSTEM_PREFERENCES_RMISSION: `You need to go to system preferences to enable screen recording permission for the current browser to share the screen`,
  ANYONE_SHARING_THE_SCREEN: `{name} is sharing the screen`,
  ARE_YOU_SURE_YOU_WANT_TO_STOP_SCREEN_SHARING: `Are you sure you want to stop screen sharing`,
  YOU_ARE_SHARING_THE_SCREEN: `You are sharing the screen`,
  STOP_SHARING: `Stop sharing`,
  SHARE_SCREEN: `Screen sharing`,
  OPEN_WHITEBOARD: `Open whiteboard`,
  STOP_WHITEBOARD: `Close whiteboard`,
  WHITEBOARD_OPENED: `Interactive whiteboard opened`,
  FAILED_TO_OPEN_WHITEBOARD_BECAUSE_OF_SCREEN_SHARING: `The sharing screen is enabled. The interactive whiteboard cannot be enabled`,
  FAILED_TO_OPEN_WHITEBOARD_BECAUSE_OF_DUPLICATED: `The interactive whiteboard has been opened and cannot be opened repeatedly`,
  FAILED_TO_SCREEN_SHARING_BECAUSE_OF_WHITEBOARD: `Interactive whiteboard is turned on, screen sharing is prohibited`,
  FAILED_TO_SCREEN_SHARING_BECAUSE_OF_DUPLICATED: `Screen sharing is enabled, interactive whiteboard is prohibited`,
  EXPORT_BEFORE_TERMINATE_WHITEBOARD: `Do you need to export the current content before ending the whiteboard?`,
  SNAPSHOT: `Snapshot`,
  EXPORT_TO_CLOUD_SPACE: `Export to cloud space`,
  EXPORT_TO_LOCAL: `Export to local`,
  EXPORTED_TO_CLOUD_SPACE: `Exported to my space`,
  TERMINATE: `Finish`,
  EXPORT: `Export`,
  DONT_EXPORT: `Do not export`,
  PERSPECTIVE_SYNCHRONIZATION: `Perspective synchronization`,
  CURRENT_PARTICIPANTS_WILL_FOLLOW_YOUR_PERSPECTIVE: `Current participants will follow your perspective`,
  THE_PERSPECTIVE_SYNCHRONIZATION_HAS_BEEN_TURNED_ON: `The perspective synchronization has been turned on, and the current participant will follow your perspective`,
  FAILED_TO_OPEN_WHITEBOARD_BECAUSE_OF_PERMISSION: `Only the host can enable whiteboard`,
  PERSPECTIVE_SYNCING: `Perspective synchronization`,
  PERSPECTIVE_OF: `Perspective`,
  YOU_ARE_CURRENTLY_IN_PERSPECTIVE_SYNCHRONIZATION: `You are currently in perspective synchronization`,
  YOU_WILL_FOLLOW: `You will follow`,
  PERSPECTIVE_SYNCHRONIZATION_IS_TURNED_ON: `Perspective synchronization is turned on`,
  TOOLBAR_SELECT: `choose`,
  TOOLBAR_BRUSH: `brush`,
  TOOLBAR_SHAPE: `shape`,
  TOOLBAR_ERASER: `rubber`,
  TOOLBAR_LASER: `laser pointer`,
  TOOLBAR_TEXT: `text`,
  ZOOM_TO_100: `Zoom to 100%`,
  ZOOM_IN: `Zoom in`,
  ZOOM_OUT: `Zoom out`,
  SCALE_TO_PROPER_SIZE: `Scale to proper size`,
  MOVE_CANVAS: `Move the canvas`,
  STOP: `Stop`,
  UNABLE_OPEN_VIDEO_ON_SCREEN: `Unable to open video on sharing screen.`,
  INPUT_OLD_CLOSE_CARAME: `Users on earlier version software are in the meeting, to ensure a stable experience, camera cannot be enabled during screen sharing`,
  DIVIECE_DISABLE_MAC: `Go to System Preferences > Security and Privacy and enable device permissions for the browser`,
  DIVIECE_DISABLE_IOS: `Go to Settings > Safari > Website Settings, enable device permissions for the browser, refresh the page, and try again`,
  DIVIECE_DISABLE_ANDROID: `Go to System Settings, enable device permissions for the browser, and refresh the page to try again`,
  DIVIECE_DISABLE_WINDOWS: `Go to Browser Settings > Privacy Settings and Security > Web Site Settings, enable device permissions, refresh the page, and try again`,
  DIVIECE_DISABLE_TITLE: `Failed to open the device`,
  BROWER_DISABLE: `The current browser is not supported. Copy the meeting address and open it using {name} browser`,
  COPY_URL: `Copying Meeting Address`,
  COPY_SUCCESS: `Copy success`,
  BROWSER_INCOMPATIBLE: `The current browser has a compatibility problem`,
  BROWSER_VERSION_UP: `Use {baseVersion} or later {browser} browsers`,
  DOWNLOAD_BROWSER: `Download browser`,
  MIC_INCOMPATIBLE: `POPO meeting request granting playback rights to audio devices`,
  MIC_CLICK_ABLE: `Browser page restrictions, please click grant permission.`,
  DISABLE_TOKEN: `The login has expired. Please re-enter the meeting address to log in`,
  WHAT_PROBLEM: `What's the problem?`,
  PBDYP: `Please briefly describe your problem`,
  OTHER: `other`,
  FEEDBACK1: `Unable to Join a meeting`,
  FEEDBACK2: `Unable to open mic`,
  FEEDBACK3: `Unable to open camera`,
  FEEDBACK4: `Audio problems`,
  FEEDBACK5: `Video problem`,
  FEEDBACK6: `Screen Sharing Issues`,
  PROMPT: `prompt`,
  FEEDBACK: `feedback`,
  CHANGENET: `The current network is abnormal. Please connect another network and try again`,
  CHECK_DEVICES_FIRST: `Check devices before joining a meeting`,
  CHECK_DEVICES: `Equipment inspection`,
  NO_DATA: `Temporarily no data`,
  MICROPHONE_CHECKER_TIPS: `Please say one word and wait a minute. Did you hear the replay?`,
  SPEAKER_CHECKER_TIPS: `Did you hear the bell?`,
  CHOOSE_MICROPHONE: `Select the microphone`,
  CHOOSE_SPEAKER: `Select speaker`,
  OUTPUT_LEVEL: `The output level`,
  INPUT_LEVEL: `The input level`,
  YES: `Yes`,
  NO_SOUND_NEXT_SPEAKER: `No. Test the next speaker`,
  NO_VOICE_NEXT_MICROPHONE: `No. Test the next mic`,
  TESTING_NTH_WITH_TOTAL_NUM: `Testing item {number} (total {total})`,
  NEXT_STEP: `The next step`,
  SPEAKER_ERR: `Your speaker is not working properly`,
  SPEAKER_MIC_ERR: `Your speaker and microphone are not working properly`,
  DEVICE_NOT_WORK: `The equipment is not working properly`,
  SPEAKER_MIC_WORKED: `The speaker and microphone work normally`,
  CHANGE_AUDIO_RECHECK: `Replace the device with an available one and debug it again`,
  END_CHECK: `The end of the test`,
  RECHECK: `To test`,
  COMPLETE: `complete`,
  JOIN_MEETING: `To join the meeting`,
  RECORDING: `recording`,
  BROADCASTING: `Now Playing`,
  MICROPHONE_RECORDING_TIPS: 'This is recording. Please say a word and wait',
  MICROPHONE_BROADCASTING_TIPS: 'It is playing. Did you hear the playback',
  APPLICATION: `Application`,
  WHITEBOARD: `Interactive whiteboard`,
  EDITOR: `Editor`,
  OPENING_INTERACTIVE_WHITEBOARD: `opening interactive whiteboard`,
  OPENING_CODE_EDITOR: `opening code editor`,
  EDITOR_CLOSED: `closed the code editor`,
  OPEN_EDITOR: `The Code Editor is turned on`,
  SWITCHED_LANG: `Switched the locale to`,
  SCREEN_SHARED: `The screen is currently being shared`,
  OTHER_SHAREDING_SCREEN: `Someone else is currently sharing the screen`,
  FAILED_TO_OPEN_CODE_EDITOR_BECAUSE_OF_SCREEN_SHARING: `Opening the code editor is not currently supported in the shared state`,
  FAILED_TO_OPEN_CODE_EDITOR_BECAUSE_OF_WHITEBOARD: `The code editor cannot be opened by the whiteboard that is already turned on`,
  FAILED_TO_SCREEN_SHARING_BECAUSE_OF_CODEEDITOR: `The code editor is already open and screen sharing is not supported at this time`,
  REFRESH: `Refresh`,
  CAMERA_IS_OFF: `Camera is off`,
  MEETING_TIME: `Time`,
  AGREE: `Agree`,
  I_AGREE_TO_THE: `I agree to the `,
  PRIVACY_POLICY: `Privacy Policy`,
  PLEASE_AGREE_TO: `Please agree to `,
  NETWORK_FAILED_REFRESH: `Network connection failed, please check the network and refresh to try again.`,
  SUPPORT_BY_QA_ZEN: `Technical support provided by QA-Zen`,
  CLOSE_COLEDITOR: 'Close Coleditor？',
  WILL_CLOSE_FOR_ALL_MEETING_ATTENDEES: 'Will close for all meeting attendees',
  ACTIVATING_TRANSCRIPTION: `Activating transcription`,
  TRANSCRIPTION_ACTIVATION_FAILED: `Transcription activation failed`,
  TRY_AGAIN: `Try again`,
  TRANSCRIPTION_LANGUAGE: `Transcription language`,
  TRANSLATE_INTO: `Translate into`,
  TRANSCRIPTION_LANGUAGE_WILL_BE_AUTOMATICALLY_DETECTED: `When selected, transcription language will be automatically detected.`,
  STOPPED_TRANSCRIPTION: `The host has stopped transcription`,
  REQUEST_TO_ACTIVATE_TRANSCRIPTION: `Request to activate transcription `,
  MEETING_TRANSCRIPTION: `Meeting transcription`,
  NO_TRANSLATE: `Don't translate`,
  TRANSCRIPTION_IS_ENABLED: `{meetingName} Transcription is enabled`,
  TRANSCRIPTION_IS_ENABLED1: `Failed to enable transcription`,
  TRANSCRIPTION_ENABLE_FAILED: `ccc`,
  AUTOMATICALLY_RECOGNIZED: `Automatically recognized`,
  RECORD: `Record`,
  REQUEST_SENT: `Request sent`,
  REQUEST_RECORDING2: `Send a request to Host to record this meeting`,
  MEETING_RECORDING_ENABLED: `Meeting recording enabled`,
  REQUEST_RECORDING: `Send a request to the Host to record this meeting? `,
  REJECT_RECORDING: `Host declined your request to activate meeting recording`,
  RECORDING2: `Recording`,
  RECORDING_PAUSED: `Recording paused`,
  RECORDING_RESUMED: `Recording resumed`,
  RECORDING_STOPPED: `Recording stopped`,
  RECORDING_CANNOT_BE_STARTED: `Recording cannot be started temporarily`,
  MORE: `More`,
  COLLAPSE2: `Collapse`,
  DEVICE_IS_ABNORMAL: `The device is abnormal, please check the device and refresh to try again`,
  INTERPRETATION_ENABLED: 'Language interpretation enabled',
  INTERPRETATION_DISABLED: 'The host disabled language interpretation',
  INTERPRETATION: 'Interpretation',
  HOST_UPDATED_YOUR_LANGUAGE_PAIR: 'The host updated your language pair',
  AUDIENCE_CHANNEL: 'Audience channel',
  MAIN_CHANNEL: 'Main channel   (Original)',
  POWERED_BY: 'Powered by NetEase Yunxin & NetEase AI Lab',
  INTERVIEW_CAMERA_TIPS:
    "Your camera is turned off by default. You may turn it on when you're prepared. To ensure communication quality, please keep your camera on during the interview.",
  ENTER_YOUR_NAME: 'Enter your name',
  INTERPRETERS: 'Interpreters',
  UNMUTE_ORIGINAL_CHANNEL: 'Unmute Original channel',
  RECEIVE_MAIN_CHANNEL: 'Main channel',
  MAIN_CHANNEL_VOICE: 'Main channel audio',
  MAIN_CHANNEL_VOICE_H5: 'Original',
  VOLUME: 'Volume',
  NOTIFY_PARTICIPANTS: 'Notify participants',
  LOGIN: 'Login',
  membershipTypeSelection: 'Select your log in method',
  oscar: 'Log in with Oscar',
  supportedAccountTypes: 'Use studio email or OC email account',
  usingOpenIDLogin: 'Log in with Open ID',
  supportsCorpEmailAccount: 'Use Corp email account',
  guestLogin: 'Log in as visitor',
  joinAsGuestEnabled: 'Join POPO meeting as a visitor',
  youAreTheHost: 'You are the host of this meeting',
  useNetEasePOPOClient: 'Please join the meeting via POPO app',
  openNetEasePOPOClient: 'Go to POPO app',
  downLoadPopo: 'Download POPO',
  noMeetingAccess: 'Access denied',
  contactMeetingOrganizer: 'Please contact the meeting organizer {name}',
  disableSubtitles: 'Close',
  enableSubtitles: 'Enable subtitles',
  isEnablingSubtitles: 'Initializing...',
  Chinese: '简体中文',
  automaticRecognition: '自动识别(Beta)',
  subtitleRegSourceLang: 'Source language',
  targetTrasLang: 'Translate into',
  switchAccounts: 'Switch account',
  guest: 'Visitor',
  big: 'Large',
  small: 'Small',
  fontSize: 'Font size',
  subtitleStatus: 'Failed to generate subtitles.',
  transcribePaused: 'Transcription stopped',
  transcribe: 'Transcribe',
  requestTranscriptionToHost: 'Apply to transcribe the meeting?',
  barrage: 'Subtitles',
  translate: 'Translate',
  openTranscribe: 'Transcription has been enabled by the host.',
  offTranscribe: 'Transcription has been stopped by the host.',
  canNotOpenTranscribe: 'Transcription unavailable.',
  newSubtitle: 'Bottom',
  refuseToEnableTranscription: 'Refuse to enable transcription',
  realTimeTranscriptionTip:
    'Real time transcription of meeting records, after the meeting ends, transcription documents can be viewed on the Learning Chicken platform',
  noPermission: 'Only the host can enable whiteboard',
  reaction: 'Reactions',
  handup: 'Raise Hand',
  handoff: 'Lower Hand',
  xHandsRaising: '{count} hands raising',
  meetingReactionsAreDisabled: 'Meeting reactions are disabled in this meeting',
  emojiSent: 'Emoji sent',
  cancelledYourRaiseOfHand: 'The host has lowered your hand',
  firstLoading: 'Loading... Please wait.',
  emoLoadedFail: 'Load failed',
  reload: 'Retry',
  exportTo: 'Export to {name}',
  audioCaptureFailed: 'Unable to detect audio. Please refresh or check your microphone.',
  grid: 'Grid',
  lecture: 'speech',
  inTranscript: 'Transcription in progress',
  meetingInformation: 'meeting information',
  onShareing: 'Sharing',
  devicAbnormality: 'Current device abnormality',
  enableScreenSharing: 'Enable screen sharing',
  openSetting: 'Open Settings',
  member: 'member',
  enableAllFocusedTa: 'Video spotlighted',
  disabledAllFocusedTa: 'Spotlight canceled',
  enableChangeFocusedTa: 'Video spotlighted',
  codeEditorFocused: 'Code editor/focus mode in progress, please close and try again',
  spotlighted: 'Spotlighted',
  temporarilyUnmute: 'Temporarily unmuted',
  turnOnTheMicrophone: 'Hold the spacebar to temporarily unmute yourself',
  turnOffTheMicrophone: `You're muted`,
  isTalking: 'Speaking:',
  unableToSwitchLayout: 'Unable to change video layout',
  inFocusedMode: 'Currently in focus mode',
  transcriptionHelpTip:
    'Real-time meeting transcription. You can view the transcription in Cloud Drive after your meeting.',
  interpretationBtnTooltip:
    'Enable language interpretation for this meeting and designate interpreters',
  availableMicrophoneIsNotDetected: 'Available microphone is not detected',
  unableToDetectCamera: 'Unable to detect  camera',
  internetConnectionTest: 'Internet connection test',
  password: 'Password',
  userName: 'Your Name',
  enterPassword: 'Meeting Password',
  errorPassword: 'Wrong password',
  mouse: 'Mouse',
  laser: 'Spotlight',
  select: 'Select',
  pen: 'Draw',
  graph: 'Shape',
  text: 'Text',
  color: 'Color',
  eraser: 'Eraser',
  undo: 'Undo',
  redo: 'Redo',
  clear: 'Clear all',
  save: 'Save',
  close: 'Close',
  setSharertoAnnotate: 'Annotation enabled for the screen sharer only',
  setSharertoAnnotateAll: 'Annotation enabled for all participants',
  openAnnotate: `{name} enabled annotation`,
  marker: 'Marker',
  lineWidth: 'Line Width',
  line: 'Line',
  oval: 'Oval',
  arrow: 'Arrow',
  rectangle: 'Rectangle',
  replaceShare: 'Start sharing your screen and end the current screen sharing session?',
  confirm: 'Start',
  penInk: 'Pen',
  meetingNeedPassword: 'Password required',
  coHost: 'Co-host',
  becomeCoHost: '{name} is now a co-host',
  revokeHostPrivileges: "{name}'s co-host permission was withdrawn",
  FAILED_TO_OPEN_WHITEBOARD_BECAUSE_OF_CODE_EDITOR:
    'Whiteboard disabled during the execution of code editor',
  popoVersionOld: "The screen sharer's POPO version does not support annotations",
  disableOpenAnnotate: 'Annotation enabled for the screen sharer only',
  unableChangeColor: 'Unable to change font color',
  openCodeFail: 'Failed to open code editor',
  reOpen: 'Reopen',
  videoCaptureFailed: 'Collection exception, please refresh the page or check the microphone',
  fullScreenView: 'In-app Full Screen Mode',
  reduceScreenSize: 'PiP Mode',
  STOPPED_AI_MINUTES: 'Host stopped AI Summary',
  STOPPED_AI_MINUTES_OTHER: 'Host stopped AI summary. Live transcript paused.',
}
